<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

// import { detectZoom } from '@/utils/detectZoom';



export default {
  name: 'App',
  mounted(){
    // const m = detectZoom();
    // document.body.style.zoom = 100 / Number(m);
  }
}
</script>

<style>
html,body,#app {
  font-family: 'Microsoft YaHei', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue